(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@emotion/react"), require("codemirror"), require("decap-cms-ui-default"));
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsWidgetCode", ["react", "@emotion/react", "codemirror", "decap-cms-ui-default"], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsWidgetCode"] = factory(require("react"), require("@emotion/react"), require("codemirror"), require("decap-cms-ui-default"));
	else
		root["DecapCmsWidgetCode"] = factory(root["React"], root["DecapCmsDefaultExports"]["EmotionCore"], root["CodeMirror"], root["DecapCmsUiDefault"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__4119__, __WEBPACK_EXTERNAL_MODULE__8110__, __WEBPACK_EXTERNAL_MODULE__9925__, __WEBPACK_EXTERNAL_MODULE__6171__) => {
return 